import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';

const NotFoundPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 8, md: 12 } }}>
      <Box
        sx={{
          p: { xs: 4, md: 6 },
          borderRadius: '24px',
          border: '1px solid rgba(15,23,42,0.08)',
          background: 'linear-gradient(180deg, #ffffff 0%, #f8fafc 100%)',
          textAlign: 'center'
        }}
      >
        <Typography variant="overline" sx={{ color: '#64748b', letterSpacing: '0.08em', fontWeight: 700 }}>
          Erro 404
        </Typography>
        <Typography variant="h3" sx={{ mt: 1, mb: 1.5, color: '#111827', fontWeight: 800 }}>
          Página não encontrada
        </Typography>
        <Typography variant="body1" sx={{ color: '#475467', mb: 3, maxWidth: '560px', mx: 'auto' }}>
          O endereço acessado não existe mais ou foi alterado. Você pode voltar para a home e continuar a navegação a partir das páginas principais da R5.
        </Typography>
        <Button
          component={RouterLink}
          to="/"
          variant="contained"
          sx={{
            borderRadius: '999px',
            px: 3,
            backgroundColor: '#cc0000',
            '&:hover': { backgroundColor: '#a80000' }
          }}
        >
          Voltar para a Home
        </Button>
      </Box>
    </Container>
  );
};

export default NotFoundPage;
